<template>
  <div @click="openTrack" class="item vertical-card pb-3 mb-2 me-1 cursor-pointer card-hover">
    <div class="image me-3">
      <img :src="track.thumbnail_url" alt="" class="author-image" loading="lazy" />
    </div>
    <div class="labels col px-1">
      <div class="font-weight-bold mt-2 card-title">{{ track.name_ar }}</div>
      <div class="text-sm">
        <div class="text-sm d-inline-block" v-for="author,index in track.authors" :key="author.id">
            {{ author.name_ar }}
            <span v-if="index != Object.keys(track.authors).length - 1" class="mx-2 font-weight-bold">· </span>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['track', 'tracklist'],

  computed: {
    selectedTrackIndex () {
      let index = 0;
      this.tracklist.forEach((t, i) => {
        if (t.id == this.track.id) {
          index = i;
        }
      });
      return index;
    }
  },

  methods: {
    openTrack(showPlayer = true) {
      if(this.$store.getters.isLoggedIn) {
        this.$store.commit('SET_TRACKLIST', { 
          tracklist: this.tracklist, 
          index: this.selectedTrackIndex,
          track: this.track,
          })
      }
      if(showPlayer) {
        this.$router.push({ name: 'Track', params: { id: this.track.id } })
      }
    }
  }
};
</script>

<style></style>
